<template>
  <div class="logo">
    <div class="logo__image">
      <img src="@/assets/vacation-investments.svg" alt="test" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo',
};
</script>

<style lang="scss" scoped>
.logo {
  position: fixed;
  bottom: -12vw;
  left: 0;
  z-index: 50;

  width: 22vw;
  height: 22vw;

  border-radius: 50%;
  background: #fff;
  box-shadow: 10px -10px 45px rgba(#000, 0.1);

  @media screen and (max-width: $lg) {
    display: none;
  }
}

.logo__image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 60%;
  height: 60%;

  position: absolute;
  bottom: 10%;
  left: 10%;

  img {
    position: absolute;
    left: 2.5vw;
    top: -7.5vw;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
